import { mutationOptions, queryOptions } from '@tanstack/react-query';

import AppError from '@lib/app-error';
import DIContainer from '@lib/dicontainer';
import { Account } from '@lib/types';

import { MutationVariables } from './types';
import { API_MODULES } from '../constants';

export const getAuthBaseQueryKey = () => [API_MODULES.AUTH];

export const getAuthBaseMutationKey = getAuthBaseQueryKey;

export const getAccountOptions = () =>
  queryOptions({
    queryKey: [...getAuthBaseQueryKey(), 'accountProfile'],
    queryFn: ({ signal }) => DIContainer.getAuthUseCase().findAccount(signal),
    retry: (failureCount, error) => {
      if (error instanceof AppError && error.status && error.status < 500) {
        return false;
      }

      return failureCount < 2;
    },
  });

export interface APILoginPayload {
  username: string;
  password: string;
}

export const loginOptions = () =>
  mutationOptions({
    mutationKey: [...getAuthBaseMutationKey(), 'login'],
    mutationFn: ({ payload }: MutationVariables<void, APILoginPayload>) =>
      DIContainer.getAuthUseCase().login(payload.username, payload.password),
  });

export const logoutOptions = () =>
  mutationOptions({
    mutationKey: [...getAuthBaseMutationKey(), 'logout'],
    mutationFn: () => DIContainer.getAuthUseCase().logout(),
  });

export interface APIForgotPasswordPayload {
  email: Account['email'];
}

export const forgotPasswordOptions = () =>
  mutationOptions({
    mutationKey: [...getAuthBaseMutationKey(), 'forgotPassword'],
    mutationFn: ({
      payload,
    }: MutationVariables<void, APIForgotPasswordPayload>) =>
      DIContainer.getAuthUseCase().forgotPassword(payload.email),
  });

export interface APIResetPasswordPayload {
  code: string;
  newPassword: string;
}

export const resetPasswordOptions = () =>
  mutationOptions({
    mutationKey: [...getAuthBaseMutationKey(), 'resetPassword'],
    mutationFn: ({
      payload,
    }: MutationVariables<void, APIResetPasswordPayload>) =>
      DIContainer.getAuthUseCase().resetPassword(
        payload.code,
        payload.newPassword,
      ),
  });
